// extracted by mini-css-extract-plugin
export default {"root":"StrategiesEmpty_root__dxCSw","animation":"StrategiesEmpty_animation__S5T9D","button":"StrategiesEmpty_button__7yGqn"};